module.exports = __webpack_public_path__ + "00893d27bc1d4dfae85f847ce0ff8888.jpg";